import React, { useCallback, useEffect, useRef, useState } from 'react'
import './style.css'
import MFHeaderLogo from '../../assets/images/mflogo-homepage.png';
import LabelText from '../../ui/LabelText';
import SearchIcon from '../../assets/icons/searchIcon-Homepage.png';
import { ForawrdBackwardButton } from '../../styled-components/PageHeaderStyles';
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import playerSearchIcon from '../../assets/icons/playersearh-homepage.png'
import clubSearchIcon from '../../assets/icons/clubsearch-homepage.png'
import MFRoadMapIcon from '../../assets/icons/mf-roadmap-icon.png';
import MFWalkThroughIcon from '../../assets/icons/mf-walkthrough-icon.svg';
import HeaderTextWithIcon from '../../components/PlayerDetail/HeaderTextWithIcon';
import CustomHeader from '../../components/PlayerDetail/CustomHeader';
import styled from 'styled-components';
import ToolLogo from '../../assets/icons/mf-tool-logo1.png';
import ToolLogoMF from '../../assets/icons/mf-tool-logo2.png';
import PrimaryButton from '../../ui/PrimaryButton';
import LabelNumber from '../../styled-components/LabelNumber';
import { ISHortlistData, IShortlistPlayers } from '../Shortlists/shortlist';
import { PlayerAvatar } from '../../styled-components/PlayerCard.Styles';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useAuth } from '../../contexts/AuthContext';
import { useLoading } from '../../contexts/LoadingContext';
import { useNotification } from '../../contexts/NotificationContext';
import { useNavigate } from 'react-router-dom';
import IApiResponse from '../../types/IApiResponse';
import { fetchData } from '../../services/api';
import apiUrls from '../../config/apiUrls';
import handleApiResponse from '../../utils/handleApiResponse';
import GlobalSearch from '../../components/GlobalSearch/GlobalSearch';
import { useSidebar } from '../../contexts/SidebarContext';
import { MFRoadMapDrawer } from '../Chemistry/UIContent';
import { debounceFunction } from '../../utils/debounceFunction';
import SearchInput from '../../ui/SearchInput';
import GlobalSearchList from '../../components/GlobalSearch/GlobalSearchList';
import { InitialSearchPlayerList } from '../../styled-components/PlayerComponent.styles';
import { ModuleSpinner } from '../../ui/LoadingSpinner/ModuleSpinner';
import { filterWomensFootball } from '../../utils/womensFootballFilter';

const StyledCustomHeader = styled.div`
    width: 1040px;
    padding-bottom:14px;  
    border-bottom: 1px solid ${({ theme }) => theme.playerDataBorder};
    color: ${({ theme }) => theme.playerColor};
    font-family: "Aeonik";
    font-size: 32px;
    font-style: normal;
    font-weight: 700;
    line-height: 40px; /* 125% */
`
interface IGlobalSearchData {
    id: number;
    imageLogoURL: string;
    isTeam: boolean;
    isAttributesFound: boolean;
    name: string;
    subName: string;
  }

  
const HomePage: React.FC<{ toggle: boolean; isSubSidebarOpen: boolean }> = () => {

    const { loading , startLoading, stopLoading } = useLoading();
    const {toggleSidebar, toggleDrawer , setActiveItemId} = useSidebar();
    const { userData } = useAuth();
    const {setDisplayNotification, setNotificationContent} = useNotification();

    const navigate = useNavigate();

    const [sortListPlayerIds, setSortListPlayerIds] = useState<number[]>([]);
    const [showPlayerComparison, setShowPlayerComparison] = useState(false);
    const [playerShortLiastData , setPlayerShortListData] = useState<IShortlistPlayers[]>()

    const [sortListClubIds, setSortListClubIds] = useState<number[]>([]);
    const [showClubComparison, setShowClubComparison] = useState(false);
    const [clubShortLiastData , setClubShortListData] = useState<IShortlistPlayers[]>()

    
    const [isShortListEmpty , setIsShortListEmpty] = useState<boolean>(false)
    const [isclunEmty , setIsclubEmpty] = useState<boolean>(false)
    const [isRoadMapDrawerOpen,setIsRoadMapDrawerOpen]= useState<boolean>(false)

    const [clearInput, setClearInput] = useState(false);
    const { moduleLoading, setModuleLoading } = useLoading();
    const [globalSearchData, setGlobalSearchData] = useState<IGlobalSearchData[]>([]);
    const [globalSearchText, setGlobalSearchText] = useState<string>("");
    const [searchInitiated, setSearchInitiated] = useState(false);
    const [isData, setIsData] = useState<boolean>(false);
    const abortControllerRef = useRef<AbortController | null>(null);
  
    //call shortlist api based on userId
    useEffect(() => {
    const fetchSortListData = async () => {
        startLoading();
        const response: IApiResponse<ISHortlistData> = await fetchData(`${apiUrls['ShortList']}${userData}`);
        handleApiResponse(response, (sortListData) => {
            stopLoading();
            localStorage.removeItem('removedIds');
            setPlayerShortListData(sortListData?.shortListPlayers)
            setClubShortListData(sortListData?.shortListTeams)
            if(sortListData?.playerIds?.length > 0){
                setSortListPlayerIds(sortListData?.playerIds)
            }
            else{
                setIsShortListEmpty(true)
                setDisplayNotification(true);
                setNotificationContent(
                <div className="notification">
                    <p className='sortlist-notofication-content'>
                        <InfoOutlinedIcon className='icon' />
                        <LabelText className="squad-chart-tooltip notification-content">
                            Short list currently empty.
                        </LabelText>
                    </p>
                </div>
                );
            }
            if(sortListData?.teamIds?.length > 0){
                setSortListClubIds(sortListData?.teamIds)
            }
            else{
                setIsclubEmpty(true)
                setDisplayNotification(true);
                setNotificationContent(
                <div className="notification">
                    <p className='sortlist-notofication-content'>
                        <InfoOutlinedIcon className='icon' />
                        <LabelText className="squad-chart-tooltip notification-content">
                            Short list currently empty.
                        </LabelText>
                    </p>
                </div>
                );
            }
        }, (error) => {
            stopLoading();
            console.error('Error fetching shortlist data :', error);
        });
        };
    fetchSortListData();
    }, [userData]);
                    
    useEffect(()=>{
        if(showPlayerComparison){
            navigate(`/shortlists/playercomparison/${userData}`, { state: { playerIds: sortListPlayerIds, isFromSortList: true, benchMarkPlayerId: null } });
        }
        if(showClubComparison){
            navigate(`/shortlists/clubcomparison/${userData}`, { state: { teamIds: sortListClubIds, isFromSortList: true, benchMarkPlayerId: null } })
        }
    },[showPlayerComparison,showClubComparison])

    const handletoggleGlobalSerach = () =>{
    toggleSidebar?.(true)
    toggleDrawer?.(true, "search");
    setActiveItemId?.("Search");
    }

    const handleSearch = useCallback(
        debounceFunction(async (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
            // Cancel previous request if exists
        if (abortControllerRef.current) {
        abortControllerRef.current.abort();
        }
        // Create a new AbortController for the current request
        const controller = new AbortController();
        abortControllerRef.current = controller;
        if (value.length >= 3) {
            setGlobalSearchText(value);
            setSearchInitiated(true);
            setModuleLoading(true);
            try {
            const response: IApiResponse<IGlobalSearchData[]> = await fetchData(
                `${apiUrls["GetTeamPlayerGlobalSearch"]}?queryString=${value}`,
                controller.signal
            );
            handleApiResponse(
                response,
                (GlobalSearchData) => {
                const filtered = filterWomensFootball(GlobalSearchData);
                if (filtered.length === 0) setIsData(true);
                else {
                    setIsData(false);
                    setGlobalSearchData(filtered);
                }
                },
                (error) => {
                console.error("Error fetching Player Search Data:", error);
                }
            );
            } catch (error) {
            console.error("Error fetching Player Search Data:", error);
            } finally {
            setModuleLoading(false);
            }
        } else {
            setGlobalSearchData([]);
            setSearchInitiated(false);
            setIsData(false);
        }
        }, 300),
        []
    );
      
    const handleClear = () => {
        setGlobalSearchText("");
        setGlobalSearchData([]);
        setSearchInitiated(false);
        setIsData(false);
    };
    const renderGlobalSearchResult = () => {
        if (searchInitiated && globalSearchData.length === 0 && isData) {
            return (
            <div className="no-result-data">
                <LabelText>No results found</LabelText>
            </div>
            );
        }
        return (
            globalSearchData.length > 0 && (
            <InitialSearchPlayerList className="search-homeglobal-list">
                <GlobalSearchList
                searchData={globalSearchData}
                searchText={globalSearchText}
                multiSelection={false}
                iconType="image"
                displayCheckBox={false}
                fromHomePage={true}
                />
            </InitialSearchPlayerList>
            )
        );
    };

        
  return (
    <div >
        <div className='main-header-container'>
            <div className='main-header-content'> 
                <img src={MFHeaderLogo} width={588} height={98}/>
            </div>
        </div>
        <div className='home-playerclub-section'>
            <div className='home-global-serach' 
            // onClick={()=>{handletoggleGlobalSerach()}}
                >
                <div className='search-header-container'>
                    <div className='search-header-text'>
                        <LabelText className='player-family-name'>Player & club analysis</LabelText>
                        <LabelText className='custom-list-strong-text'>Deep dive any player or club from over 70 professional leagues across the world</LabelText>
                    </div>
                    <div>
                        <img src={SearchIcon} />
                    </div>
                </div>
                {/* <div className='search-bar'>
                    <LabelText className='custom-list-text'>Search players and clubs</LabelText>
                </div> */}
                <div className="player-search-data" style={{width: '100%'}}>
                <div className="container active" style={{background:'rgba(249, 250, 247, 0.80)'}}>
                        <SearchInput
                        handleSearch={handleSearch}
                        handleClear={handleClear}
                        placeholder={"Search players and clubs"}
                        fontSize="32px"
                        type="SearchPlayer"
                        clearInput={clearInput}
                        autoFocus={false}
                        />
                    </div>
                    {renderGlobalSearchResult()}
                    {moduleLoading && <ModuleSpinner />}
                </div>
            </div>
            <div className='playerclub-list-section'>
                <div className='playerlist' onClick={()=>{navigate('/playersearch')}}>
                    <div className='home-list-container'>
                        <div className='list-header-container'>
                            <div className='list-header-content'>
                                <LabelText className='player-family-name'>Player comparison</LabelText>
                                <ForawrdBackwardButton style={{background: 'rgba(242, 245, 238, 0.80)',width:'64px',height:'64px',border:'none'}}>
                                    <KeyboardArrowRightIcon fontSize="large"/>
                                </ForawrdBackwardButton>
                            </div>
                            <LabelText className='custom-list-strong-text'>Our player analysis engine searches and compares over 120,000 players</LabelText>
                        </div>
                        <div className='home-searchbar-conatiner'>
                            <img src={playerSearchIcon}/>
                            <div>
                                <LabelText className='home-playerlist-boldtext'>Search by: </LabelText>
                                <LabelText className='home-playerlist-normaltext'>position, playing style, performance, transfer value, wages, geography and league </LabelText>
                            </div>

                        </div>
                    </div>
                </div>
                <div className='playerlist' onClick={()=>{navigate('/clubsearch')}}>
                    <div className='home-list-container'>
                        <div className='list-header-container'>
                            <div className='list-header-content'>
                                <LabelText className='player-family-name'>Club comparison</LabelText>
                                <ForawrdBackwardButton style={{background: 'rgba(242, 245, 238, 0.80)',width:'64px',height:'64px',border:'none'}}>
                                    <KeyboardArrowRightIcon fontSize="large" />
                                </ForawrdBackwardButton>
                            </div>
                            <LabelText className='custom-list-strong-text'>Over 2000 clubs playing style, system fit, age, and contractual profile</LabelText>
                        </div>
                        <div className='home-searchbar-conatiner'>
                            <img src={clubSearchIcon}/>
                            <div>
                                <LabelText className='home-playerlist-boldtext'>Also included: </LabelText>
                                <LabelText className='home-playerlist-normaltext'>Financial reports, squad value & transfer history for leading clubs</LabelText>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='playerclub-list-section'>
                <div className='home-searchbar-conatiner' style={{width:'485px'}}>
                            <img src={MFWalkThroughIcon} className="responsive-icon"/>
                            <div style={{textWrap:'balance'}}>
                                <LabelText className='home-playerlist-normaltext'>For a deep dive on the platform, check out the </LabelText>
                                <LabelText className='home-playerlist-boldtext' style={{textDecoration:'underline',cursor:'pointer'}}
                                onClick={() => window.open("https://docs.google.com/presentation/d/1ecCNpX-q-YyHoVDySgWmZ-tle2Km_g3SzSUKm3UbQxA/edit#slide=id.g31fa59547c2_0_4", "_blank")}> 
                                System walkthrough </LabelText>
                            </div>
                </div>
                <div className='home-searchbar-conatiner' style={{width:'485px'}}>
                            <img src={MFRoadMapIcon} className="responsive-icon"/>
                            <div style={{textWrap:'balance'}}>
                                <LabelText className='home-playerlist-normaltext'>For a look at what we’re working on, see the </LabelText>
                                <LabelText className='home-playerlist-boldtext' style={{textDecoration:'underline',cursor:'pointer'}}
                                onClick={()=>{setIsRoadMapDrawerOpen(true)}}
                                > 
                                MF feature roadmap </LabelText>
                            </div>
                </div>
            </div>
            
        </div>
        <div className='home-tools-section'>
                    <StyledCustomHeader>Tools</StyledCustomHeader>
                    <div className='home-tools-container'>
                        <div className='home-tools'>
                            <div className='tools-upper-section'>
                                <div style={{display:'flex'}}>
                                    <LabelText className='player-family-name'>GBE calculator</LabelText>
                                    <div className='mf-tool-logo-container' ><img src={ToolLogoMF}/></div>
                                </div>
                                <LabelText className='home-tool-text'>Calculator player eligibility and points allocations</LabelText>
                                <PrimaryButton className="login-button" disabled={true} label="Coming soon"/>
                            </div>
                        </div>
                        <div className='home-tools'>
                            <div className='tools-upper-section'>
                                <div style={{display:'flex',gap:'4px'}}>
                                    <LabelText className='player-family-name'>FFP modelling</LabelText>
                                    <div className='mf-tool-logo-container' style={{background:'#4AF075'}}><img src={ToolLogo}/></div>
                                </div>
                                <LabelText className='home-tool-text'>Model outcomes against FFP boundaries</LabelText>
                                <PrimaryButton className="login-button" disabled={true} label="Coming soon"/>
                            </div>
                        </div>
                        <div className='home-tools'>
                            <div className='tools-upper-section'>
                                <div style={{display:'flex'}}>
                                    <LabelText className='player-family-name'>Player loan valuation</LabelText>
                                    <div className='mf-tool-logo-container' style={{background:'#FF3864'}}><img src={ToolLogoMF}/></div>
                                </div>
                                <LabelText className='home-tool-text'>Select candidate clubs and predict player future value</LabelText>
                                <PrimaryButton className="login-button" disabled={true} label="Coming soon"/>
                            </div>
                        </div>
                    </div>
        </div>
        <div className='home-tools-section'>
                <StyledCustomHeader>Your shortlists</StyledCustomHeader>
                <div className='shortlists-categories-container' style={{marginTop:'0px'}}>
                            <div className='shortlists-categories-content' onClick={()=>{setShowPlayerComparison(true)}}>
                                <LabelText className='player-detail-family-name'>Players</LabelText>
                                
                                {isShortListEmpty ? (
                                    <div className='shortlist-empty'>
                                        <LabelNumber className='chart-content-number'>Shortlist empty</LabelNumber>
                                    </div>
                                ):(
                                    <div className='list-content'>
                                        {playerShortLiastData?.slice(0, 11).map((player: IShortlistPlayers, index: number) => (
                                                <PlayerAvatar 
                                                    className="categories-avatar" 
                                                    backgroundImage={player.imageDataURL} 
                                                />
                                        ))}
                                        {playerShortLiastData?.length! > 11 && (
                                                <div className='counter-icon'>
                                                    <LabelText className='profile-name'>+{playerShortLiastData?.length! - 11}</LabelText>
                                                </div>
                                        )}
                                    </div>
                                )}
                            
                            </div>
                            <div className='shortlists-categories-content'  onClick={()=>{setShowClubComparison(true)}}>
                                <LabelText className='player-detail-family-name'>Clubs</LabelText>
                                {isclunEmty ? (
                                    <div className='shortlist-empty'>
                                        <LabelNumber className='chart-content-number'>Shortlist empty</LabelNumber>
                                    </div>
                                ):(
                                    <div className='list-content'>
                                        {clubShortLiastData?.slice(0, 11).map((player: IShortlistPlayers, index: number) => (
                                                <img 
                                                    // className="categories-avatar" 
                                                    width={64}
                                                    height={64}
                                                    src={player.imageDataURL} 
                                                />
                                        ))}
                                        {clubShortLiastData?.length! > 11 && (
                                                <div className='counter-icon'>
                                                    <LabelText className='profile-name'>+{clubShortLiastData?.length! - 11}</LabelText>
                                                </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
        </div>
        {isRoadMapDrawerOpen  && <MFRoadMapDrawer
            isRoadMapDrawerOpen={isRoadMapDrawerOpen}
            setIsRoadMapDrawerOpen={setIsRoadMapDrawerOpen}
        />}
    </div>
  )
}

export default HomePage